export enum UserEventType {
  ZALOZENIE_KONTA = 'Utworzenie konta',
  ZALOGOWANIE_DO_SYSTEMU = 'Zalogowanie',
  WYLOGOWANIE_UZYTKOWNIKA_Z_SYSTEMU = 'Wylogowanie',
  ZAPIS_ZMIENIONYCH_DANYCH_SWOJEGO_KONTA = 'Zapis zmienionych danych swojego konta',
  DODANIE_NOWEGO_CZLONKA_RODZINY = 'Dodanie nowego członka rodziny',
  USUNIECIE_CZLONKA_RODZINY = 'Usunięcie członka rodziny',
  ZAPIS_ZMIENIONYCH_DANYCH_CZLONKA_RODZINY = 'Zapis zmienionych danych członka rodziny',
  WYZNACZENIE_ADRESATA_DOKUMENTU = 'Wyznaczenie adresata dokumentu',
  UTWORZENIE_NOWEGO_DOKUMENTU = 'Utworzenie nowego dokumentu',
  ZAPIS_ZMODYFIKOWANEGO_DOKUMENTU_ROBOCZEGO = 'Zapis wniosku roboczego',
  USUNIECIE_DOKUMENTU_ROBOCZEGO = 'Usunięcie dokumentu roboczego',
  DODANIE_ZALACZNIKA_DO_DOKUMENTU = 'Dodanie załącznika do dokumentu',
  USUNIECIE_ZALACZNIKA_DO_DOKUMENTU = 'Usunięcie załącznika do dokumentu',
  ZAPIS_ZMODYFIKOWANEGO_ZALACZNIKA_DO_DOKUMENTU = 'Zapis zmodyfikowanego załącznika do dokumentu',
  WYBOR_METODY_DOSTARCZENIA_DOKUMENTU_ZWROTNEGO = 'Wybór metody dostarczenia dokumentu zwrotnego',
  WYSLANIE_DOKUMENTU = 'Wysłanie wniosku',
  AKCEPTACJA_REGULAMINU = 'Zatwierdzenie regulaminu',
  WYSLANIE_ZAPROSZENIA_DO_ORGANIZACJI = 'Zaproszenie do zarządzania organizacją',
  PRZYJECIE_ZAPROSZENIA_DO_ORGANIZACJI = 'Przyjęcie zaproszenia do zarządzania organizacją',
  ZMIANA_ROLI_REPREZENTANTA_ORGANIZACJI = 'Zmiana roli reprezentanta organizacji',
  USUNIECIE_REPREZENTANTA_ORGANIZACJI = 'Usunięcie reprezentanta organizacji',
  AKTUALIZACJA_DANYCH_ORGANIZACJI = 'Aktualizacja danych organizacji',
  ZAPIS_PELNOMOCNICTWA_REPREZENTANTA = 'Zapis pełnomocnictwa reprezentanta',
  USUNIECIE_PELNOMOCNICTWA_REPREZENTANTA = 'Usunięcie pełnomocnictwa reprezentanta',
  DEZAKTYWACJA_KONTA = 'Dezaktywacja konta użytkownika',
  OTWARCIE_ZAPROSZENIA_DO_ORGANIZACJI = 'Otwarcie zaproszenia do organizacji',
  ZMIANA_KONTEKSTU_APLIKACJI = 'Zmiana kontekstu aplikacji',
  ZMIANA_WLASCICIELA_ORGANIZACJI = 'Zmiana właściciela organizacji',
  ZMIANA_WLASCICIELA_ORG_USUNIECIE_REPRE = 'Zmiana właściciela organizacji i usunięcie reprezentanta',
  PRZEJECIE_INSTYTUCJI_ORGANIZACJI = 'Przejęcie instytucji organizacji',
  PROBA_WYSZUKANIA_UZYTKOWNIKA = 'Próba wyszukania użytkownika',
  OPUBLIKOWANIE_KOMUNIKATU = 'Opublikowanie komunikatu',
  BRAK_POTWIERDZENIA_W_TERMINIE_ZAPROSZENIA_DO_ORGANIZACJI = 'Brak potwierdzenia w terminie zaproszenia do zarządzania organizacją',
  ZABLOKOWANIE_UZYTKOWNIKA = 'Zablokowanie',
  ODBLOKOWANIE_UZYTKOWNIKA = 'Odblokowanie',
  NADANIE_PRAWA_ADMINA = 'Nadanie prawa admina',
  ODEBRANIE_PRAWA_ADMINA = 'Odebranie prawa admina',
  ODCZYTANIE_KOMUNIKATU = 'Odczytanie komunikatu',
  DODANIE_DO_ORGANIZACJI = 'Dodanie do organizacji',
}
